import axios from 'axios';
import { IResponse } from '~/services/api/types';
import {
  IDeviceHistoryLog,
  IDeviceHistoryLogsListFilters,
  IPatientDeviceHistoryLog,
} from './types';

const apiUrl = 'device-history-logs';

export const getList = (params: IDeviceHistoryLogsListFilters): IResponse<IDeviceHistoryLog[]> =>
  axios({
    method: 'get',
    url: apiUrl,
    params,
  });

export const getByPatientId = (patientId: number): IResponse<IPatientDeviceHistoryLog[]> =>
  axios({
    method: 'get',
    url: `${apiUrl}/by-patient-id/${patientId}`,
  });

export default {};
